import { reactive } from 'vue';

export const userAccessStore = reactive({
  access: null,
})
